import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminApi } from '../api/adminApi';
import { adminKeys } from '../api/adminQueryKeys';
export function useSetAdultFlag() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ workId, isAdult }) => adminApi.setAdultFlag(workId, isAdult),
        onSuccess: (_data, { workId }) => {
            qc.invalidateQueries({ queryKey: adminKeys.workDetail(workId) });
            qc.invalidateQueries({ queryKey: adminKeys.works() });
            qc.invalidateQueries({ queryKey: adminKeys.stats() });
        },
    });
}
